<main class="main-container">
    <div class="d-flex align-items-center justify-content-center loading-overlay" *ngIf="globalSpinner.show">
        <flex-component-spinner [size]="120"></flex-component-spinner>
    </div>
    <flex-header></flex-header>

    <router-outlet></router-outlet>


    <flex-footer></flex-footer>
</main>


